/**
 * 统一把后端错误变成一句能读的话。
 *
 * FastAPI 的 422 里 `detail` 是一个数组（每项 {type, loc, msg, input, url}），
 * 不是字符串。直接把它塞进 antd 的 Alert / message 会抛
 * 「Objects are not valid as a React child」——真正的校验原因反而被这个崩溃盖住。
 */
interface ValidationItem {
  loc?: Array<string | number>
  msg?: string
}

export function describeError(err: unknown, fallback = '操作失败'): string {
  const detail = (
    err as { response?: { data?: { detail?: unknown } } }
  )?.response?.data?.detail

  if (typeof detail === 'string' && detail.trim()) return detail

  if (Array.isArray(detail)) {
    const parts = (detail as ValidationItem[])
      .map((item) => {
        // loc 形如 ["body","breeding_objective"]，末段才是字段名
        const field = Array.isArray(item.loc) ? String(item.loc[item.loc.length - 1]) : ''
        const msg = item.msg ?? ''
        return field ? `${field}: ${msg}` : msg
      })
      .filter(Boolean)
    if (parts.length) return parts.join('；')
  }

  const message = (err as Error)?.message
  return message || fallback
}
